import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import {getManager} from "../../../ts/manager/Manager";
import React from "react";
import {assert} from "../../../ts/common/Assert";
import StateViewController from "../../vc/StateViewController";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import {IFactoryData} from "../../../ts/model-factory/basic/ModelFactoryInterface";
import Error404Partial from "../../partial/status/Error404Partial";
import DataModel from "../../../ts/model-factory/basic/data/DataModel";
import NavRelatedPagesView from "../../partial/nav/NavRelatedPagesView";
import {PostType} from "../../../ts/manager/post/PostManager";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import moment from "moment/moment";
import {phpToMomentDateFormat} from "../../../ts/common/SiteHelper";
import PostAddPage from "./PostAddPage";

const MyProfilePage = (props:IRouteProps) =>
{
    const organisationID = getManager().user.organisationID;

    const organisationModel = getModelFactory().postData.getPostDataModel("organisation", true);
    const myProfileRouteModel = getManager().navigation.model.routeModels.myProfile
    const organisation = organisationModel.choiceList()[0] ?? null;
    const childPostType:PostType|null = organisation?.primaryChildPostType ?? null;

    const childPostConfig = childPostType ? (getManager().post.config[childPostType] ?? null) : null;

    const childPostTypeRouteModel = childPostType ? getModelFactory().postRoute.getDefaultModel(childPostType) : null;
    const childPostTypeListRouteModel = childPostType ? getModelFactory().postListRoute.getDefaultModel(childPostType, true) : null;
    const postActivityDataModel = getModelFactory().postActivityData.postActivityDataModel(organisationID);

    const doAssert:(IFactoryData|null)[] = [myProfileRouteModel];
    const dataModels: DataModel|(DataModel|null)[] = [];
    if(organisationID){
        doAssert.push(organisation);
        dataModels.push(organisationModel)
        dataModels.push(childPostTypeListRouteModel?.sourceDataModel ?? null)
        dataModels.push(postActivityDataModel)

    }

    const viewState = StateViewController({
        routeProps: props,
        dataModels: dataModels,
        assert: doAssert
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    assert(myProfileRouteModel);


    const notOrganisationSection = () => {
        const accountRouteModel = getModelFactory().accountRoute.getDefaultModel();
        return <>
            <PostAddPage {...props}/>
            <NavRelatedPagesView
                routeProps={props}
                routeModel={accountRouteModel}
                title={"Manage your account"}
            />
        </>
    }

    if(!organisationID){
        return notOrganisationSection()
    }

    const childPostColumn = () => {
        const addRouteChoice = childPostTypeRouteModel?.choices.add ?? null;
        const listRouteChoice = childPostTypeRouteModel?.choices.list ?? null;
        if(!childPostConfig || !addRouteChoice || !listRouteChoice){
            return ""
        }
        return <>
            <h2 className="block-title mb-5">{childPostConfig.plural ?? ""}</h2>

            <ul className="vertical-icons">
                <li>
                    <RouteChoiceButton
                        routeChoice={listRouteChoice}
                        label={"Your " + childPostConfig.plural}
                    />
                </li>
                <li>
                    <RouteChoiceButton
                        routeChoice={addRouteChoice}
                        label={"Submit " + childPostConfig.aName}
                    />
                </li>
            </ul>
        </>
    }

    const activityColumn = () =>
    {
        const activityRouteChoice = myProfileRouteModel.choices.activity;
        if (!activityRouteChoice)
        {
            return ""
        }

        const choiceList = postActivityDataModel.choiceList().slice();
        choiceList.length = Math.min(choiceList.length, 6);
        return <>
            <h2 className="block-title mb-5">Activity</h2>

            {!!choiceList.length ? <>

                {choiceList.map((choice, index) =>
                {
                    return <div key={index} className="activity-box">
                        <h3>{moment(choice.createdDate).format(phpToMomentDateFormat('j M Y'))} @ {moment(choice.createdDate).format(phpToMomentDateFormat('g:ia'))}</h3>
                        <div className="wysiwyg-content">{choice.readableMessage}</div>
                    </div>
                })}
            </> : <>
                <div className="activity-box">
                    <div className="wysiwyg-content">
                        <p>There has been no activity yet with your organisation</p>
                    </div>
                </div>
            </>}

            <p>
                <RouteChoiceButton
                    routeChoice={activityRouteChoice}
                    className="btn reduced"
                    label={"All activity"}
                />
            </p>
        </>
    }

    const accountColumn = () => {
        const accountRouteModel = getModelFactory().accountRoute.getDefaultModel();
        const accountRouteChoice = myProfileRouteModel.choices.account;
        if(!accountRouteChoice){
            return ""
        }
        return <>
            <h2 className="block-title mb-5">Account</h2>


            <p className="mb-4">Logged in as <strong>{getManager().user.profile.getName()}</strong> of <strong>{organisation?.name ?? ""}</strong>.</p>
            <ul className="vertical-icons">

                {accountRouteModel.choiceList().map((choice, index) =>
                {
                    return <li key={index}>
                        <RouteChoiceButton
                            routeChoice={choice}
                        />
                    </li>
                })}

            </ul>
        </>
    }

    return <>
        <section className="content-block">
            <div className="container">

                <div className="row d-flex row-cols-1 row-cols-lg-3 g-5">

                    <div className="col">
                        {childPostColumn()}
                    </div>
                    <div className="col">
                        {activityColumn()}
                    </div>
                    <div className="col">
                        {accountColumn()}
                    </div>
                </div>
            </div>
        </section>
    </>
}

export default MyProfilePage;